const AppConstants = {
  cloudlasResourceEndPoint: "https://testcloudlasresources.azurewebsites.net/",
  Views: {
    Home: "/",
    ContactUs: "/ContactUs",
    PrivacyPolicy: "/PrivacyPolicy",
    TermsOfUse: "/TermsOfUse",
    EULA: "/EULA",
    Products: {
      KPI: "/Products/KPI",
      Directory: "/Products/Directory",
      HelpDesk: "/Products/HelpDesk",
      ScrumMaster: "/Products/ScrumMaster",
    },
    Documentation: {
      KPI: "/Documentation/KPI",
      Directory: "/Documentation/Directory",
      HelpDesk: "/Documentation/HelpDesk",
      ScrumMaster: "/Documentation/ScrumMaster",
    },
  },
};
export default AppConstants;
